import { render, staticRenderFns } from "./FinalizacaoAprovarReprovar.vue?vue&type=template&id=4320b38e"
import script from "./FinalizacaoAprovarReprovar.vue?vue&type=script&lang=js"
export * from "./FinalizacaoAprovarReprovar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports